{
  "el": {
    "toast": {
      "action": {
        "failed": "Η ενέργεια απέτυχε",
        "impersonate_unauthorized": "Αυτή η ενέργεια δεν επιτρέπεται κατά την υπόδυση πελάτη.",
        "storage_quota_exceeded": "Έφτασες το όριο αποθηκευτικού χώρου. Διάγραψε αρχεία ή επικοινώνησε μαζί μας για αναβάθμιση του πλάνου σου.",
        "succeeded": "Η ενέργεια ολοκληρώθηκε",
        "unprocessable": "Κάτι πήγε στραβά, δοκίμασε να ανανεώσεις τη σελίδα. Αν το πρόβλημα συνεχιστεί, επικοινώνησε μαζί μας. \nΣφάλμα: {error}"
      },
      "create": {
        "failed": "Αποτυχία δημιουργίας {itemName}",
        "succeeded": "{itemName} δημιουργήθηκε"
      },
      "delete": {
        "failed": "Αποτυχία διαγραφής {itemName}",
        "succeeded": "{itemName} διαγράφηκε",
        "succeeded_default": "Η διαγραφή ολοκληρώθηκε"
      },
      "update": {
        "failed": "Αποτυχία ενημέρωσης {itemName}",
        "succeeded": "{itemName} ενημερώθηκε",
        "successfully_saved": "Αποθηκεύτηκε με επιτυχία"
      },
      "upload": {
        "failed": "Το ανέβασμα απέτυχε",
        "succeeded": "Το ανέβασμα ολοκληρώθηκε"
      },
      "upload_document": {
        "extension_invalid": "Το έγγραφο «{document_name}» δεν έχει έγκυρη επέκταση."
      },
      "upload_image": {
        "file_too_big": "Πολύ μεγάλο αρχείο: το μέγιστο μέγεθος είναι 5MB"
      },
      "warning": {
        "multipleFiles": "Αυτή η εξαγωγή περιέχει πολλά αρχεία zip. Το πρόγραμμα περιήγησής σου μπορεί να μπλοκάρει τις πολλαπλές λήψεις. Επικοινώνησε με την υποστήριξη της Ziggu αν κατέβηκε μόνο 1 αρχείο zip."
      }
    }
  }
}
